import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { loanApplicationSignalRConnection } from 'app/services/signalR';

import { PresenceSignalRMessageType } from 'constants/presence';
import useLoanId from 'hooks/useLoanId';
import { logger } from 'utils/logger';

import { getUuid } from 'store/auth/selectors';
import { selectAllFieldLocks } from 'store/presence/selectors';

const useReleaseFieldLocksOnTabChange = activeTab => {
  const loanId = useLoanId();

  const fieldLocks = useSelector(selectAllFieldLocks);
  const currentUserId = useSelector(getUuid);

  const previousTabRef = useRef(activeTab);

  useEffect(() => {
    if (previousTabRef.current === activeTab) {
      return;
    }

    previousTabRef.current = activeTab;

    const myFieldPaths = Object.entries(fieldLocks)
      .filter(([, lock]) => lock.userId === currentUserId)
      .map(([fieldPath]) => fieldPath);

    if (!myFieldPaths.length) {
      return;
    }

    loanApplicationSignalRConnection
      .invoke(PresenceSignalRMessageType.RELEASE_FIELD_LOCKS, loanId, ...myFieldPaths)
      .catch(err => {
        logger.error('Failed to release field locks on tab change', {
          loanId,
          fieldPaths: myFieldPaths,
          err,
        });
      });
  }, [activeTab, fieldLocks, currentUserId, loanId]);
};

export default useReleaseFieldLocksOnTabChange;
